import { Component, Input } from '@angular/core';
import { NbPosition } from '@nebular/theme';

/**
 * Erklärtext einer Seite hinter einem Fragezeichen oben rechts im Seitenkopf.
 * Der Text steht als Inhalt im Element (auch Links / mehrere Absätze) und
 * erscheint beim Klick als Pop-up — er steht nicht mehr als `.subtitle`
 * unter dem Seitentitel. Platzierung im Kopf: `styles.scss` „Seitenhilfe".
 */
@Component({
  selector: 'app-page-help',
  templateUrl: './page-help.component.html',
  styleUrl: './page-help.component.scss',
})
export class PageHelpComponent {
  @Input() placement: NbPosition | `${NbPosition}` = NbPosition.BOTTOM_END;
}
